import './ScrollProgressBar.css'

import React, { useState, useEffect } from 'react';

const ScrollProgressBar = () => {
  const [scrollWidth, setScrollWidth] = useState(0);

  useEffect(() => {
    const updateBlueLine = () => {
      const scrollTop = window.scrollY;
      const documentHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const newWidth = (scrollTop / documentHeight) * 100;
      setScrollWidth(newWidth);
    };

    window.addEventListener('scroll', updateBlueLine);

    return () => {
      window.removeEventListener('scroll', updateBlueLine);
    };
  }, []);

  return (
    <div>
      <div
        className="blue-line"
        style={{ width: `${scrollWidth}%` }}
      ></div>
    </div>
  );
};

export default ScrollProgressBar;
